import type { CustomerId } from "types/customer"
import type { Route } from "types/not-yet-sorted"
import type { ControlDesk } from "types/region"
import { PBRoutes } from "./pb"
import { roadsRoutes } from "./roads"
import { getSIPRoutes } from "./sip"
import { thirdRailRoutes } from "./thirdRail"
import { wagonRoutes } from "./wagon"

// Desks that have Sites Requiring Review
const SRR_DESKS: ControlDesk[] = ["Wessex", "LNW North", "Scotland", "Western", "North and East", "Anglia", "Wales", "East Midlands"]

export const getRoutes = (
  customerId: CustomerId,
  isUserSuperAdmin: boolean,
  controlDesks: ControlDesk | ControlDesk[] = [],
): Route[] => {
  switch (customerId) {
    case "RAIL":
    case "NR": {
      // Several desks ticked (ART-3177): a page is available if any of them has it.
      const desks = Array.isArray(controlDesks) ? controlDesks : [controlDesks]
      return getSIPRoutes({
        srr: desks.some((desk) => SRR_DESKS.includes(desk)),
        tickSheets: true,
        internal: isUserSuperAdmin,
      })
    }
    case "PB":
      return PBRoutes
    case "WAGON":
      return wagonRoutes
    case "3RDRAIL":
      return thirdRailRoutes
    case "SCC":
    case "MED":
    case "KCC":
    case "WOK":
    case "FMC":
    case "DFI":
    case "HOU":
    case "PET":
    case "ROADS":
    case "RRD":
    case "ANDY":
    case "ABDS":
    case "BCP":
    case "JER":
    case "CAM":
    case "CFX":
    case "EDI":
    case "WBRK":
    case "LGW":
    case "EGKK":
    case "LHR":
    case "LAN":
    case "PIC":
    case "ESUS":
    case "ESS":
    case "USDEMO":
    case "RR":
    case "DON":
    case "RCM":
    case "ILN":
    case "NOR":
    case "HERT":
    case "GLOU":
    case "MKE":
    case "DVN":
    case "BUCK":
    case "NH":
    case "STOC":
    case "WSUS":
    case "NBL":
    case "EKFB":
    case "AGB":
    case "TAM":
    default:
      return roadsRoutes.filter((route) => (isUserSuperAdmin ? true : !route.internal))
  }
}
